import { DesignProp } from "../PropCategories";

export const borderColor = {
  prop: "style-attribute",
  name: "Border color",
  nameI18n: "builder_ui.prop_type.styles.border_color",
  category: [DesignProp],
  type: "color",
  defaultValue: "#000000",
} as const;
